import { render, staticRenderFns } from "./PlaceFilter.vue?vue&type=template&id=4ef9f899&"
import script from "./PlaceFilter.vue?vue&type=script&lang=js&"
export * from "./PlaceFilter.vue?vue&type=script&lang=js&"
import style0 from "./PlaceFilter.vue?vue&type=style&index=0&id=4ef9f899&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports